import {lazy} from "react"

const ProfileView = lazy(() => import('components/profile/view/ProfileView'))
const ProfileEdit = lazy(() => import('components/profile/edit/ProfileEdit'))
const Notifications = lazy(() => import('components/notifications/Notifications'))
const Bookmark = lazy(() => import('components/bookmarks/Bookmarks'))

const ArticleDashboard = lazy(() => import('components/resources/dashboard/ArticleDashboard'))

const DiscussionAdd= lazy(() => import('components/discussions/add/DiscussionAdd'))

export const routes = {
   '/profile': {
      label: 'Profile',
      component: ProfileView,
      exact: true
   },
   '/profile/edit': {
      label: 'Edit Profile',
      component: ProfileEdit,
      exact: true
   },
   '/bookmarks': {
      label: 'Bookmarks',
      component: Bookmark,
      exact: true
   },
   '/notifications': {
      label: 'Notifications',
      component: Notifications,
      exact: true
   },
   '/resources/dashboard': {
      label: 'Article Dashboard',
      component: ArticleDashboard,
      exact: true
   },
   '/discussions/add': {
      label: 'Add Discussion',
      component: DiscussionAdd,
      exact: true
   }
}
